module.exports = __webpack_public_path__ + "static/media/mobile6.a877d918.png";